export enum platform {
    iOS = 'iOS',
    android = 'android',
    web = 'web'
}

export class mobileversionModel {
    platform: platform;
    app_version: string;
    app_min_version: string;
}

export class AppVersion extends mobileversionModel {
    app_guid: string;
    created_at: Date;
}

export class deleteVersion {
    app_guid: string[] = [];
}
